import { render, staticRenderFns } from "./SpreadLonger.vue?vue&type=template&id=c75ef896&scoped=true&"
import script from "./SpreadLonger.vue?vue&type=script&lang=js&"
export * from "./SpreadLonger.vue?vue&type=script&lang=js&"
import style0 from "./SpreadLonger.vue?vue&type=style&index=0&id=c75ef896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75ef896",
  null
  
)

export default component.exports